export default __webpack_public_path__ + "static/media/opengl.f5950486.svg";